var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwomark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Status=default",
    clipPath: "url(#clip0_9146_80486)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic twomark",
    clipPath: "url(#clip1_9146_80486)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.58326 14.997C4.26326 14.997 3.94326 14.8753 3.6991 14.6311L0.365762 11.2978C-0.122572 10.8095 -0.122572 10.0186 0.365762 9.53031C0.854095 9.04198 1.64493 9.04198 2.13326 9.53031L4.58326 11.9795L12.0324 4.53031C12.5208 4.04198 13.3116 4.04198 13.7999 4.53031C14.2883 5.01865 14.2883 5.80948 13.7999 6.29781L5.4666 14.6311C5.22326 14.8753 4.90326 14.997 4.58326 14.997Z",
    fill: "#BFDFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.4168 14.997C10.0968 14.997 9.77676 14.8753 9.53259 14.6311L6.19926 11.2978C5.71092 10.8095 5.71092 10.0186 6.19926 9.53031C6.68759 9.04198 7.47842 9.04198 7.96676 9.53031L10.4159 11.9795L17.8651 4.53031C18.3534 4.04198 19.1443 4.04198 19.6326 4.53031C20.1209 5.01865 20.1209 5.80948 19.6326 6.29781L11.2993 14.6311C11.0568 14.8753 10.7368 14.997 10.4168 14.997Z",
    fill: "#2894FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9146_80486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9146_80486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwomark);
export default __webpack_public_path__ + "static/media/twomark.0e36cd98644fc05780e69a50b3217350.svg";
export { ForwardRef as ReactComponent };